import React, { useEffect, useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { SupplierDto } from 'appDtos';
import { Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AdministrationPaths } from '../../../shared/api/constants';
import { AppPaths } from '../../../shared/appConstants';
import { AlertComponent } from '../../../shared/components';
import { Loading } from '../../../shared/components';
import { useApi } from '../../../shared/hooks/useApi';
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError';

export function Suppliers() {
  const [suppliers, setSuppliers] = useState<SupplierDto[]>([]);
  const [loading, setLoading] = useState(true);
  const API = useApi();
  const { setError, errorMessage } = useApiHandleError();
  const goTo = useNavigate();

  useEffect(() => {
    const get = async () => {
      try {
        const response = await API.get(AdministrationPaths.GetSuppliers());
        if (response.data) {
          setSuppliers(response.data);
        }
      } catch (error) {
        setError(error)
      }
      setLoading(false);
    }
    get();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <PageHeader pageTitle='Suppliers' navPath={AppPaths.getCreateSupplier()}/>
      <AlertComponent message={errorMessage} />
      {loading ? (
        <Loading />
      ) : (
        suppliers.length > 0 ? 
        <ListGroup numbered as="ol">
        {
          suppliers.map((supplier,i) => (
              <ListGroup.Item key={supplier.supplierId} action as="li" className="d-flex justify-content-between align-items-start clicable" onClick={() => goTo(AppPaths.getSupplierDetail(supplier.supplierId))}>
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{supplier.name}</div>
                </div>
              </ListGroup.Item>
            ))
        }
        </ListGroup>
        : (
          <AlertComponent message="No supplier has been created." variant="info"/>
        )
      )}
    </Container>)
}
